import App from './App.svelte'
import './main.scss'

/* eslint-disable no-unused-vars */
import Dropdown from '../node_modules/bootstrap/js/dist/dropdown'
import Collapse from '../node_modules/bootstrap/js/dist/collapse'
import Modal from '../node_modules/bootstrap/js/dist/modal'
/* eslint-enable no-unused-vars */

// Sentry
if (process.env.SENTRY_DSN) {
  console.log('Initializing Sentry with DSN', process.env.SENTRY_DSN)
  import('@sentry/browser').then((Sentry) => {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
    })
  })
}

// I18n
import { addMessages, init, getLocaleFromNavigator } from 'svelte-i18n'
import en from './translations/en.json'
import de from './translations/de.json'
addMessages('en', en)
addMessages('de', de)

init({
  fallbackLocale: 'en',
  initialLocale: getLocaleFromNavigator(),
})

// Initialize Svelte App
const app = new App({
  target: document.body,
  props: {},
})

export default app
